import { DeleteEmptyGroupsModal} from "./DeleteEmptyGroupsModal";

export default DeleteEmptyGroupsModal;
